export interface Product {
  id: number;
  name: string;
  price: number;
  originalPrice: number;
  image: string;
  category: string;
  ageRange: string;
  size: string;
  condition: 'Excellent' | 'Good' | 'Very Good';
  badge?: string;
  description: string;
}

export const products: Product[] = [
  {
    id: 1,
    name: 'Floral Summer Set',
    price: 8.99,
    originalPrice: 24.00,
    image: 'https://public.readdy.ai/ai/img_res/fb2656dc88ac15d51f7db35e1b164fe5.jpg',
    category: 'Clothing 1-3 yrs',
    ageRange: '1-3 yrs',
    size: '2T',
    condition: 'Excellent',
    badge: 'POPULAR',
    description: 'Beautiful two-piece set with floral print. Ruffled top with matching shorts. In perfect condition.'
  },
  {
    id: 2,
    name: 'Classic Denim Overalls',
    price: 11.50,
    originalPrice: 30.00,
    image: 'https://readdy.ai/api/search-image?query=denim%20overalls%20dungarees%20for%20baby%20toddler%20flat%20lay%20white%20background%20clean%20minimal%20product%20photography%20children%20clothing%20cute&width=400&height=400&seq=p2&orientation=squarish',
    category: 'Clothing 1-3 yrs',
    ageRange: '1-3 yrs',
    size: '18M',
    condition: 'Very Good',
    description: 'Classic denim overalls for babies. Comfortable and durable. Shoulder snaps for easy diaper changes.'
  },
  {
    id: 3,
    name: 'Pink Knit Dress',
    price: 7.50,
    originalPrice: 20.00,
    image: 'https://readdy.ai/api/search-image?query=knit%20pink%20dress%20for%20little%20girl%20age%204%205%20flat%20lay%20white%20background%20clean%20minimal%20product%20photography%20children%20clothing%20cute%20pastel&width=400&height=400&seq=p3&orientation=squarish',
    category: 'Clothing 4-7 yrs',
    ageRange: '4-7 yrs',
    size: '5',
    condition: 'Excellent',
    badge: 'NEW',
    description: 'Adorable soft pink knit dress. Stretchy and cozy fabric, perfect for everyday wear.'
  },
  {
    id: 4,
    name: 'Orange Puffer Jacket',
    price: 14.99,
    originalPrice: 45.00,
    image: 'https://readdy.ai/api/search-image?query=orange%20puffer%20jacket%20for%20kid%20age%206%207%20flat%20lay%20white%20background%20clean%20minimal%20product%20photography%20children%20clothing%20winter%20coat&width=400&height=400&seq=p4&orientation=squarish',
    category: 'Clothing 4-7 yrs',
    ageRange: '4-7 yrs',
    size: '6',
    condition: 'Very Good',
    description: 'Warm puffer jacket in vibrant orange. Full zip with side pockets. Perfect for fall and winter.'
  },
  {
    id: 5,
    name: 'Jogger & Hoodie Set',
    price: 12.00,
    originalPrice: 35.00,
    image: 'https://readdy.ai/api/search-image?query=kids%20sweatsuit%20jogger%20pants%20and%20hoodie%20set%20for%20boy%20age%208%2010%20flat%20lay%20white%20background%20clean%20minimal%20product%20photography%20children%20clothing%20sporty&width=400&height=400&seq=p5&orientation=squarish',
    category: 'Clothing 8-12 yrs',
    ageRange: '8-12 yrs',
    size: '10',
    condition: 'Excellent',
    badge: 'POPULAR',
    description: 'Athletic jogger and hoodie set. Soft french terry fabric, great for everyday or sports activities.'
  },
  {
    id: 6,
    name: 'Dark Blue Slim Jeans',
    price: 9.99,
    originalPrice: 28.00,
    image: 'https://readdy.ai/api/search-image?query=dark%20blue%20slim%20jeans%20for%20kid%20age%209%2012%20flat%20lay%20white%20background%20clean%20minimal%20product%20photography%20children%20clothing%20denim%20pants&width=400&height=400&seq=p6&orientation=squarish',
    category: 'Clothing 8-12 yrs',
    ageRange: '8-12 yrs',
    size: '12',
    condition: 'Good',
    description: 'Classic slim fit jeans in dark blue. Goes with everything. Minor wear marks, barely noticeable.'
  },
  {
    id: 7,
    name: 'Wooden Educational Blocks',
    price: 13.50,
    originalPrice: 38.00,
    image: 'https://readdy.ai/api/search-image?query=colorful%20wooden%20building%20blocks%20educational%20toy%20for%20toddlers%20flat%20lay%20white%20background%20clean%20minimal%20product%20photography%20kids%20toy%20rainbow&width=400&height=400&seq=p7&orientation=squarish',
    category: 'Toys',
    ageRange: '1-3 yrs',
    size: 'One Size',
    condition: 'Excellent',
    badge: 'NEW',
    description: 'Set of 30 colorful wooden blocks in various shapes. Stimulates creativity and motor development. Non-toxic paint.'
  },
  {
    id: 8,
    name: 'Wooden Play Kitchen',
    price: 19.99,
    originalPrice: 65.00,
    image: 'https://readdy.ai/api/search-image?query=kids%20play%20kitchen%20toy%20wooden%20pastel%20colors%20flat%20lay%20white%20background%20clean%20minimal%20product%20photography%20children%20pretend%20play&width=400&height=400&seq=p8&orientation=squarish',
    category: 'Toys',
    ageRange: '3-7 yrs',
    size: 'One Size',
    condition: 'Very Good',
    badge: 'POPULAR',
    description: 'Play kitchen set with accessories included: pots, pan and utensils. In very good condition with all pieces.'
  },
  {
    id: 9,
    name: '100-Piece Animal Puzzle',
    price: 6.00,
    originalPrice: 15.00,
    image: 'https://readdy.ai/api/search-image?query=colorful%20100%20piece%20jigsaw%20puzzle%20for%20kids%20animals%20forest%20flat%20lay%20white%20background%20clean%20minimal%20product%20photography%20children%20game&width=400&height=400&seq=p9&orientation=squarish',
    category: 'Toys',
    ageRange: '5-10 yrs',
    size: 'One Size',
    condition: 'Excellent',
    description: '100-piece puzzle featuring a forest animals illustration. Complete — all pieces present. Ages 5+.'
  },
  {
    id: 10,
    name: 'Plaid Flannel Shirt',
    price: 6.50,
    originalPrice: 18.00,
    image: 'https://readdy.ai/api/search-image?query=plaid%20flannel%20shirt%20for%20boy%20age%205%206%20flat%20lay%20white%20background%20clean%20minimal%20product%20photography%20children%20clothing%20checkered%20pattern&width=400&height=400&seq=p10&orientation=squarish',
    category: 'Clothing 4-7 yrs',
    ageRange: '4-7 yrs',
    size: '5',
    condition: 'Good',
    description: 'Green and red plaid flannel shirt. Perfect for fall. All buttons intact, no stains.'
  },
  {
    id: 11,
    name: 'Tulle Party Dress',
    price: 15.00,
    originalPrice: 55.00,
    image: 'https://readdy.ai/api/search-image?query=tulle%20party%20dress%20for%20girl%20age%207%208%20flat%20lay%20white%20background%20clean%20minimal%20product%20photography%20children%20clothing%20princess%20pink%20elegant&width=400&height=400&seq=p11&orientation=squarish',
    category: 'Clothing 8-12 yrs',
    ageRange: '8-12 yrs',
    size: '8',
    condition: 'Excellent',
    badge: 'NEW',
    description: 'Beautiful layered tulle party dress in dusty pink. Back zipper closure. Only worn once.'
  },
  {
    id: 12,
    name: 'Remote Control Car',
    price: 16.00,
    originalPrice: 45.00,
    image: 'https://readdy.ai/api/search-image?query=remote%20control%20car%20toy%20for%20kids%20red%20yellow%20flat%20lay%20white%20background%20clean%20minimal%20product%20photography%20children%20rc%20car%20colorful&width=400&height=400&seq=p12&orientation=squarish',
    category: 'Toys',
    ageRange: '5-12 yrs',
    size: 'One Size',
    condition: 'Very Good',
    description: 'Battery-powered remote control car. Includes remote and batteries. Works perfectly, minor normal use marks.'
  },
  {
    id: 13,
    name: 'LEGO Classic Brick Set',
    price: 18.50,
    originalPrice: 55.00,
    image: 'https://readdy.ai/api/search-image?query=lego%20classic%20colorful%20brick%20building%20set%20toy%20for%20kids%20flat%20lay%20white%20background%20clean%20minimal%20product%20photography%20children%20creative%20blocks%20vibrant%20colors&width=400&height=400&seq=p13&orientation=squarish',
    category: 'Toys',
    ageRange: '4-12 yrs',
    size: 'One Size',
    condition: 'Very Good',
    badge: 'POPULAR',
    description: 'Large LEGO classic brick set, 500+ pieces in all colors. All pieces present and clean. Endless building fun.'
  },
  {
    id: 14,
    name: 'Soft Baby Doll',
    price: 7.00,
    originalPrice: 22.00,
    image: 'https://readdy.ai/api/search-image?query=soft%20baby%20doll%20plush%20toy%20for%20little%20girl%20toddler%20flat%20lay%20white%20background%20clean%20minimal%20product%20photography%20children%20stuffed%20cute%20sweet&width=400&height=400&seq=p14&orientation=squarish',
    category: 'Toys',
    ageRange: '1-4 yrs',
    size: 'One Size',
    condition: 'Excellent',
    description: 'Adorable soft baby doll with closing eyes. Washable fabric, very hygienic. Comes with a little onesie outfit.'
  },
  {
    id: 15,
    name: 'Magnetic Drawing Board',
    price: 5.50,
    originalPrice: 14.00,
    image: 'https://readdy.ai/api/search-image?query=magnetic%20drawing%20board%20doodle%20pad%20kids%20toy%20colorful%20flat%20lay%20white%20background%20clean%20minimal%20product%20photography%20children%20educational%20art&width=400&height=400&seq=p15&orientation=squarish',
    category: 'Toys',
    ageRange: '2-6 yrs',
    size: 'One Size',
    condition: 'Good',
    description: 'Magnetic drawing and writing board with stylus. No mess, reusable. Great for travel and quiet play.'
  },
  {
    id: 16,
    name: 'Dinosaur Action Figures Set',
    price: 9.00,
    originalPrice: 26.00,
    image: 'https://readdy.ai/api/search-image?query=dinosaur%20action%20figures%20set%20toy%20for%20kids%20colorful%20plastic%20flat%20lay%20white%20background%20clean%20minimal%20product%20photography%20children%20t-rex%20triceratops&width=400&height=400&seq=p16&orientation=squarish',
    category: 'Toys',
    ageRange: '3-10 yrs',
    size: 'One Size',
    condition: 'Very Good',
    badge: 'NEW',
    description: 'Set of 8 detailed plastic dinosaur figures. T-Rex, Triceratops, Brachiosaurus and more. Great for imaginative play.'
  },
  {
    id: 17,
    name: 'Kids Art Supply Kit',
    price: 8.00,
    originalPrice: 22.00,
    image: 'https://readdy.ai/api/search-image?query=kids%20art%20supply%20kit%20colored%20pencils%20watercolors%20crayons%20set%20flat%20lay%20white%20background%20clean%20minimal%20product%20photography%20children%20creative%20drawing%20painting&width=400&height=400&seq=p17&orientation=squarish',
    category: 'Toys',
    ageRange: '4-12 yrs',
    size: 'One Size',
    condition: 'Good',
    description: 'Complete art kit with colored pencils, watercolors, crayons and brushes. Most materials lightly used, great value.'
  },
  {
    id: 18,
    name: 'Balance Bike',
    price: 22.00,
    originalPrice: 70.00,
    image: 'https://readdy.ai/api/search-image?query=kids%20balance%20bike%20toddler%20yellow%20green%20clean%20flat%20lay%20white%20background%20minimal%20product%20photography%20children%20bike%20outdoor%20toy&width=400&height=400&seq=p18&orientation=squarish',
    category: 'Toys',
    ageRange: '2-5 yrs',
    size: 'One Size',
    condition: 'Very Good',
    badge: 'POPULAR',
    description: 'Lightweight balance bike, adjustable seat height. No pedals — great for learning balance before a regular bike. Minor scratches.'
  },
  {
    id: 19,
    name: 'Farmyard Playset',
    price: 12.00,
    originalPrice: 38.00,
    image: 'https://readdy.ai/api/search-image?query=kids%20farmyard%20playset%20toy%20animals%20barn%20wooden%20colorful%20flat%20lay%20white%20background%20clean%20minimal%20product%20photography%20children%20pretend%20play%20animals&width=400&height=400&seq=p19&orientation=squarish',
    category: 'Toys',
    ageRange: '2-6 yrs',
    size: 'One Size',
    condition: 'Excellent',
    description: 'Wooden farm playset with barn, 10 animals and fencing. All pieces present. Sustainably made, no toxic paint.'
  },
  {
    id: 20,
    name: 'Board Game Bundle (3 games)',
    price: 14.00,
    originalPrice: 42.00,
    image: 'https://readdy.ai/api/search-image?query=board%20games%20bundle%20for%20kids%20family%20box%20colorful%20flat%20lay%20white%20background%20clean%20minimal%20product%20photography%20children%20games%20fun&width=400&height=400&seq=p20&orientation=squarish',
    category: 'Toys',
    ageRange: '5-12 yrs',
    size: 'One Size',
    condition: 'Very Good',
    badge: 'NEW',
    description: 'Bundle of 3 classic board games: Snakes & Ladders, Memory Match, and Connect Four. All complete with all pieces.'
  },
];

export const categories = ['All', 'Clothing 1-3 yrs', 'Clothing 4-7 yrs', 'Clothing 8-12 yrs', 'Toys'];
export const conditions = ['Excellent', 'Very Good', 'Good'];
export const sizes = ['18M', '2T', '3T', '4', '5', '6', '8', '10', '12', 'One Size'];
